import React, { useState } from 'react';
import { Select } from '@shared/UI';
import { useClientDetailsTable } from '../lib';
import SecurityStore from '@widgets/BrokerLevelPositionsTabs/store/security-store';
import './BrokerLevelPostionFilters.scss';

export const BrokerLevelPositionFilters: React.FC = () => {
    const { setSecurityType } = useClientDetailsTable();

    const [securityType, setSelectedSecurityType] = useState<any>();
    const securities = SecurityStore();

    const handleSelect = (selectedValues: any[]) => {
        setSelectedSecurityType(selectedValues); // Update local state
        setSecurityType(selectedValues); // Update the table context
    };

    return (
        <div className='widget-security-table-filters'>
            <Select
                multiple
                currentValue={securityType}
                options={
                    securities.securities
                        ? securities.securities.map((security) => ({
                              label: security.symbol,
                              value: security.securityId,
                          }))
                        : []
                }
                fromDropdown='Security'
                placeholder='Select Security Types'
                onSelect={handleSelect}
                inputWrapperClassName='widget-dtc-reports-table-filters select'
            />
        </div>
    );
};
